import type { ReactNode } from 'react';
import { useAppSelector } from '../app/hooks';
import { selectDrawerOpen } from '../features/ui/uiSlice';
import { Drawer } from './Drawer';
import { DrawerNav } from './DrawerNav';
import { ThemeSwitch } from './ThemeSwitch';
import { useApplyTheme } from './useApplyTheme';

export interface WorkspaceProps {
  /** Fills the screen (usually the editor). */
  readonly children: ReactNode;
  /** Page-specific options, shown in the drawer below the navigation. */
  readonly options?: ReactNode;
  readonly title: string;
  /** Replaces the drawer's plain title heading. */
  readonly heading?: ReactNode;
  /** Bottom panel below the main content, e.g. a {@link TerminalDrawer}. */
  readonly terminal?: ReactNode;
}

/** The app's page shape: full-screen content plus the right-hand options drawer. */
export function Workspace({ children, options, title, heading, terminal }: WorkspaceProps) {
  const drawerOpen = useAppSelector(selectDrawerOpen);
  useApplyTheme();
  return (
    <div className="workspace" data-drawer-open={drawerOpen}>
      <main className="workspace-main">
        <div className="workspace-content">{children}</div>
        {terminal}
      </main>
      <Drawer title={title} heading={heading} brand={<strong className="brand">🍝 Pasta</strong>}>
        <DrawerNav />
        {options}
        <hr />
        <ThemeSwitch />
      </Drawer>
    </div>
  );
}
